/* istanbul ignore file */
import { registerDefaultsForModule } from '@glu/theming';
import legacy from './themes/legacyTheme';
import ash from './themes/ashTheme';

const themes = { ash, legacy };

registerDefaultsForModule('datepickerReact', ({ name, palette, typography }) =>
  themes[name](palette, typography)
);
